import React from 'react';
import {ThemedView, ThemedText} from '@app/theme';
import Button from '@sharedComponents/Button/Button';
import SecureIcon from "../../../../../assets/Icons/Secure";

interface KYCSummaryBottomViewProps {
  checkBox1Checked: boolean;
  checkBox2Checked: boolean;
  handleSuccess: () => void;
  colors: any;
  ctaLoader: boolean
}

const KYCSummaryBottomView: React.FC<KYCSummaryBottomViewProps> = ({
  checkBox1Checked,
  checkBox2Checked,
  handleSuccess,
  colors,
  ctaLoader
}) => {
  return (
    <ThemedView justifyContent={'flex-end'} bottom={0} mt={"sm"}>
      <ThemedView justifyContent={"flex-end"} borderTopWidth={1} borderColor={"border-primary"}/>
      <ThemedView flexDirection={"row"} justifyContent={"center"} alignItems={"center"} mt={"lg"}>
        <SecureIcon fill={colors['icon-emphasis-secondary']}/>
        <ThemedText variant={"b4r"} color={"text-emphasis-secondary"} ml={"sm"}>
          Your data is secure with us
        </ThemedText>
      </ThemedView>
      <ThemedView paddingHorizontal={"lg"} paddingTop={"sm"} paddingBottom={"lg"}>
        <Button
          eventName='KYC_SUMMARY_CONFIRM'
          label="Confirm"
          type="SOLID"
          size='MD'
          disabled={!checkBox1Checked || !checkBox2Checked}
          handlePress={handleSuccess}
          bg={colors['bg-action-primary']}
          textColor={colors['text-primary']}
          buttonLoader={ctaLoader}
        />
      </ThemedView>
    </ThemedView>
  );
};

export default KYCSummaryBottomView; 